import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const ExcluirPrestServico = () => {
    const { id } = useParams();
    const navigate = useNavigate();    ;
    const { showNotification } = useNotification();
    const url = `service-provider/${id}`;

    const handleDelete = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch(url, {
                method: 'DELETE',                
            });

            if (!response.ok) throw new Error('Erro ao excluir prestador');

            showNotification("success", "Prestador excluído com sucesso!");
            navigate('/PrestServicos');
        } catch (error) {
            showNotification("danger", "Erro ao excluir prestador");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <aside>
                    <h4 className="font-weight-bolder mb-0">Excluir Prestador de Serviço</h4>
                </aside>
                <form onSubmit={handleDelete}>
                    <fieldset className="col-md-6">
                        <p>Tem certeza que deseja excluir o prestador?</p>
                        <div className="card-footer" style={{ paddingLeft: "0" }}>
                            <Link to="/PrestServicos" className="btn btn-info btn-sm">Cancelar</Link>
                            <button type="submit" className="btn btn-danger btn-sm mx-1">Excluir</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    );
};

export default ExcluirPrestServico;
